import {
  ChangeDetectionStrategy,
  Component,
  input
} from "@angular/core";

@Component({
  selector: "app-package-title",
  templateUrl: "./package-title.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageTitleComponent {
  title = input<string>();
  subTitle = input<string>();
}
